export const EMPLOYEE_PERFORMANCE_GRADE = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
};

export const FETCH_ALL_EMPLOYEES_SALARIES = 'PEOPLE_MANAGEMENT_EMPLOYEE_PERFORMANCE_FETCH_ALL_EMPLOYEES_SALARIES';
export const CALCULATE_EMPLOYEE_PERCENTILE = 'PEOPLE_MANAGEMENT_EMPLOYEE_PERFORMANCE_CALCULATE_EMPLOYEE_PERCENTILE';
export const PERFORMANCE_MEASUREMENT_GET = 'PEOPLE_MANAGEMENT_EMPLOYEE_PERFORMANCE_CALCULATE_EMPLOYEES_SCORE';

export const EMPLOYEE_COMPETENCY_LEVEL = {
  L0: 'L0',
  L1: 'L1',
  L2: 'L2',
  L3: 'L3',
  L4: 'L4',
  L5: 'L5',
  L6: 'L6',
} as const;

export type QualificationCompetencyLevel = keyof typeof EMPLOYEE_COMPETENCY_LEVEL;
